import { Injectable } from "@angular/core";
import { IID_OL_RIFERIMENTI_UI } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolRiferimentiUiStore } from "./iidOlRiferimentiUi.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_RIFERIMENTI_UI)
export class IIDolRiferimentiUiQuery extends AbstractInterfaceDataQuery<IID_OL_RIFERIMENTI_UI> {
  constructor(protected store: IIDolRiferimentiUiStore) {
    super(store);
  }
}
